<template>
  <b-modal
    id="ModalExcluirProduto"
    :no-close-on-backdrop="loadingExcluir"
    :no-close-on-esc="loadingExcluir"
  >
    <Header mini titulo="Excluir Produto" icone="times-circle" cor="vermelho" slot="modal-header" />
    <div class="modal-excluir-empresa-corpo">
      <LoadingPadraoContainer
        v-if="loadingExcluir"
        class="loading-padrao-backdrop"
        background
        :fraseLoading="['Excluindo Produto', 'Aguarde um momento']"
        delay="5000"
        classe="azul"
      />

      <div>
        {{
          `Tem certeza que deseja remover o produto "${
            dadosProdutoDelete && dadosProdutoDelete.nome ? dadosProdutoDelete.nome : ""
          }" ?`
        }}
      </div>
      <div>
        O monitoramento do produto também será removido.
      </div>
    </div>
    <template slot="modal-footer">
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Cancelar"
        icone="times"
        :click="cancelar"
        :desabilita="loadingExcluir"
      />
      <BotaoPadrao
        arredondadoEsquerda
        class="botao-modal"
        nome="Excluir"
        icone="check"
        :click="handleClick"
        :desabilita="loadingExcluir"
        cor="vermelho"
      />
    </template>
  </b-modal>
</template>

<script>
import LoadingPadraoContainer from "@/components/LoadingPadrao/LoadingPadraoContainer.vue";
import BotaoPadrao from "@/components/BotaoPadrao/BotaoPadrao.vue";
import Header from "@/components/ModalComponente/Header.vue";

import Api from "@/services/api.js";
import { mapGetters } from "vuex";

export default {
  name: "ModalExcluirProduto",
  components: {
    LoadingPadraoContainer,
    BotaoPadrao,
    Header
  },
  props: {
    dadosProdutoDelete: Object
  },
  data() {
    return {
      loadingExcluir: false
    };
  },
  created() {
    window.addEventListener("keydown", this.handleKey);
  },
  beforeDestroy() {
    window.removeEventListener("keydown", this.handleKey);
  },
  computed: {
    ...mapGetters("empresa", ["getEmpresa"])
  },
  methods: {
    async handleKey(event) {
      let modal = document.getElementById("ModalExcluirProduto");
      if (modal.classList.contains("show")) {
        if (event.key === "Enter") {
          await this.handleClick();
        }
      }
    },
    async handleClick() {
      this.loadingExcluir = true;
      await new Api().post("Produto/excluirProdutos", {
        produtos: [{ id: this.dadosProdutoDelete.id }],
        blTodos: false,
        idEmpresa: this.getEmpresa.id
      });
      this.loadingExcluir = false;
      this.$emit("atualiza");
      this.$root.$emit("bv::hide::modal", "ModalExcluirProduto");
    },
    cancelar() {
      this.$root.$emit("bv::hide::modal", "ModalExcluirProduto");
    }
  }
};
</script>

<style lang="scss" scoped>
.modal-excluir-empresa-corpo {
  text-align: center;
}
</style>
